<div
  id="variable_container"
  class="variable_container"
  [@tabState]="state"
  [ngStyle]="{ top: topPosition }"
  >
  @if (show) {
    <div class="variable_bugerMenuBox" [hidden]="hidden" (click)="openVariable()">
      <button class="variable_burgerMenu">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </button>
    </div>
  }
  <div class="variable_header">
    <button class="variable_burgerMenu">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </button>
    <span class="variable_title"> Variables & Shortcuts</span>
    <button class="variable_close" (click)="closeVariable()">
      <img src='../../../../../assets/svg/close.svg' style="width: 15px; height: 15px" />
    </button>
  </div>
  <div class="variable_list">
    @if (currentId !== 'validationPattern') {
      <ul>
        @for (variable of variablesItems; track variable) {
          <li (click)="copyVarReg(variable)">{{ variable }}</li>
        }
      </ul>
    }
    @if (variableList.length != 0) {
      <table style="width: 100%">
        @for (varValue of variableList; track varValue) {
          <tr>
            <td id="varKey" class="variablesContext">{{ varValue }}</td>
          </tr>
        }
      </table>
    }
    @if (currentId === 'validationPattern') {
      <ul class="regex_list">
        @for (regex of regexLibrary; track regex) {
          <li class="regex_item" (click)="copyVarReg(regex.pattern)">
            <span class="regex_name">{{ regex.name }}</span>
            <span class="regex_pattern">{{ regex.pattern }}</span>
          </li>
        }
      </ul>
    }
  </div>
</div>
